<template>
  <BCard no-body v-draggable class="popup text-dark">
    <BCardHeader
      style="height: 25px; user-select: none;"
      class="ps-2 pb-0 pt-0"
      header-tag="div"
    >
      <BRow class="mx-0 px-0">
        <BCol class="mx-0 px-0" cols="11">
          Rechnung {{edit ? 'bearbeiten' : 'erstellen'}}
        </BCol>
        <BCol class="mx-0 px-0" cols="1" style="display: flex; justify-content: end;">
          <div @click="$emit('close')">
            <FontAwesomeIcon
              class="mx-1 clickable"
              icon="fa-solid fa-xmark"
              style="cursor:pointer;"
            />
          </div>
        </BCol>
      </BRow>
    </BCardHeader>

    <BCardBody style="overflow-y: auto;">
      <p>Rechnung für: <b>{{selectedOrder.SubProjectName + ' - ' + selectedOrder.OrderName}}</b></p>
      <BForm @submit="onSubmit">
        <BRow>
          <BCol>
            <!-- Input InvoiceCode -->
            <BFormGroup
              label="Rechnungsnummer:"
              label-for="input-invoiceCode"
            >
              <BFormInput
                id="input-invoiceCode"
                v-model="invoice.InvoiceCode"
                type="text"
                placeholder="Rechnungsnummer..."
                required
              ></BFormInput>
            </BFormGroup>
            <!-- Input amount -->
            <BFormGroup
              label="Summe netto:"
              label-for="input-invoiceAmount"
            >
              <BFormInput
                id="input-invoiceAmount"
                v-model="invoice.InvoiceAmount"
                type="number"
                placeholder="Summe netto..."
                required
                :step="0.01"
                :min="0"
              ></BFormInput>
            </BFormGroup>
            <!-- Input amount gross -->
            <BFormGroup
              label="Summe brutto:"
              label-for="input-invoiceAmountGross"
            >
              <BFormInput
                id="input-invoiceAmountGross"
                v-model="invoice.InvoiceAmountGross"
                type="number"
                placeholder="Summe brutto..."
                required
                :step="0.01"
                :min="0"
              ></BFormInput>
            </BFormGroup>
            <!-- Input isPaid -->
            <BFormGroup
              label="Bezahlt:"
              label-for="input-isPaid"
              style="display: flex"
            >
              <BFormCheckbox
                id="input-isPaid"
                class="mx-2"
                v-model="invoice.IsPaid"
                required
              ></BFormCheckbox>
            </BFormGroup>
          </BCol>
          <BCol>
            <!-- Input Year -->
            <BFormGroup
              label="Wirtschaftsjahr:"
              label-for="input-invoiceYear"
            >
              <BFormSelect
                id="input-invoiceYear"
                v-model="invoice.Year"
                :options="selectedOrder.AllYearsOfOrder"
                required
              ></BFormSelect>
            </BFormGroup>
            <!-- Input Date -->
            <BFormGroup
              label="Datum:"
              label-for="input-invoiceDate"
            >
              <BFormInput
                id="input-invoiceDate"
                v-model="invoice.InvoiceDate"
                type="date"
                placeholder="Datum..."
                required
              ></BFormInput>
            </BFormGroup>
            <!-- Input DueDate -->
            <BFormGroup
              label="Fällig:"
              label-for="input-invoiceDate"
            >
              <BFormInput
                id="input-invoiceDate"
                v-model="invoice.DueDate"
                type="date"
                placeholder="Fällig..."
                required
              ></BFormInput>
            </BFormGroup>
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BFormGroup
              label="Bemerkung:"
              label-for="input-note"
            >
              <BFormTextarea
                id="input-note"
                v-model="invoice.Note"
                v-html="invoice.Note"
                :state="(!invoice.Note || invoice.Note?.length <= 50)"
                placeholder="max. 50 Zeichen"
                no-resize
              >
              </BFormTextarea>
            </BFormGroup>
          </BCol>
        </BRow>
        <BRow>
          <BCol v-if="edit" style="display: flex; height: fit-content; justify-content: left;">
            <BButton class="m-2" @click="$emit('deleteInvoice')" variant="danger" >Löschen</BButton>
            <BButton class="m-2" @click="$emit('cancelInvoice')" variant="warning">{{ invoice.IsCanceled ? "Reaktivieren" : "Stornieren" }}</BButton>
          </BCol>
          <BCol style="display: flex; height: fit-content; justify-content: right;">
            <BButton class="m-2" type="submit" variant="primary" :disabled="formChanges === 0 || invoice.Note?.length >= 50">Speichern</BButton>
            <BButton class="m-2" @click="$emit('close')" variant="secondary">Abbrechen</BButton>
          </BCol>
        </BRow>
      </BForm>
    </BCardBody>
  </BCard>
</template>

<script>
import ControllingService from '../services/ControllingService';
// import Treeselect from '@zanmato/vue3-treeselect'

export default {
  name: "InvoiceEditPopup",
  emits: ['close', 'close-reload', 'deleteInvoice', 'cancelInvoice'],
  components: {
    // Treeselect
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    selectedInvoice: {
      type: Object,
      default: null
    },
    selectedOrder: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      formChanges: 0,
      invoice: {
        InvoiceAmount: null,
        InvoiceCode: null,
        InvoiceDate: null,
        IsPaid: false,
        Year: null,
        OrderId: null,
        DueDate: null,
        Note: '',
        InvoiceAmountGross: null
      }
    }
  },
  watch: {
    invoice: {
      handler() {
        this.formChanges++;
      },
      deep: true
    },
  },
  mounted() {
    if(this.selectedInvoice && this.edit){
      this.invoice = JSON.parse(JSON.stringify(this.selectedInvoice));
    } else {
      this.invoice.Year = this.selectedOrder.AllYearsOfOrder[this.selectedOrder.AllYearsOfOrder.length - 1]
    }
    this.invoice.OrderId = JSON.parse(JSON.stringify(this.selectedOrder.OrderId));
    if(this.invoice.Note === null) this.invoice.Note = '';

    // wait for all to be mounted
    setTimeout(() => {
      this.formChanges = 0;
    }, 100);
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      var invoiceData = JSON.parse(JSON.stringify(this.invoice));
      if(invoiceData.Note === '') invoiceData.Note = null;
      ControllingService.setInvoice(invoiceData)
      .then((res) => {
        this.$emit('close-reload');
      });
    },
  },
}
</script>

<style scoped>
.popup {
  width: 50vw;
  max-height: 80%;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
.upload-button-container {
  position: absolute;
  z-index: 10;
  transform: translate(0%,-111%);
  width: 90%;
  text-align: right;
}
.clickable {
  cursor: pointer;
}
.disabled-color {
  color: grey;
}
</style>